import Combine from '../../components/Combine/Combine';
import AffiliatePage from './AffiliatePage';

const Affiliate = () => {
  return <Combine> <AffiliatePage/></Combine>;
}

export default Affiliate
